import { default as AppNav } from './app-nav';

export default AppNav;



// WEBPACK FOOTER //
// ./src/components/partials/app-nav/index.js